import { useEffect } from "react";

const useHeartbeat = (userId) => {
  useEffect(() => {
    if (!userId) return;

    const interval = setInterval(() => {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/api/heartbeat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });
    }, 60 * 1000); // every 1 minute

    return () => clearInterval(interval); // cleanup on unmount
  }, [userId]);
};

export default useHeartbeat;
